import { render } from "./CropSizePackagesByMonths.vue?vue&type=template&id=5bd21677"
import script from "./CropSizePackagesByMonths.vue?vue&type=script&lang=js"
export * from "./CropSizePackagesByMonths.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__